export const readListFilter = (key: string, fallback = ''): string => {
  const value = new URLSearchParams(window.location.search).get(key);

  return value === null ? fallback : value;
};

export const backToList = (
  navigate: (to: any, options?: any) => void,
  fallback: string,
): void => {
  const historyIndex = window.history.state?.idx || 0;

  if (historyIndex > 0) {
    navigate(-1);
    return;
  }

  navigate(fallback);
};

export const readListPage = (): number => {
  const page = Number(readListFilter('page', '1'));

  return Number.isFinite(page) && page > 0 ? page : 1;
};
